export default {
    "id": "ID",
    "dashboard": "仪表板",
    "warning": "警告",
    "users": "用户",
    "farms": "农场",
    "animals": "动物",
    "action": "行动",
    "actionList": "行动清单",
    "drugInventory": "药品库存",
    "inseminatorStatistics": "授精统计",
    "organizationNTR": "组织NTR",
    "genotypePerformance": "基因型表现",
    "semenAutomation": "精液自动化",
    "activityLogs": "活动日志",
    "username": "用户名",
    "title": "标题",
    "deactivated": "已停用",
    "name": "姓名",
    "email": "电子邮件",
    "emailAddress": "电子邮件地址",
    "mobileNum": "手机号码",
    "emailOrMobile": "电子邮件/手机",
    "role": "角色",
    "roles": "角色",
    "department": "部门",
    "status": "地位",
    "pages": "页数",
    "departments": "部门",
    "password": "密码",
    "cancel": "取消",
    "submit": "提交",
    "error": "错误",
    "success": "成功",
    "Browse": "浏览",
    "orDropYourFileCsvXlsXlsxHere": "或将您的文件（CSV、XLS、XLSx）拖放到此处",
    "search": "搜索",
    "apply": "申请",
    "select": "选择",
    "previous": "以前的",
    "mandatory": "强制的",
    "dropYourFileHere": "或将您的文件（CSV、XLS、XLSx、PDF、Docx、PNG、JPEG）拖放到此处",
    "restoreDefault": "恢复默认",
    "pending": "待办的",
    "completed": "完全的",
    "remove": "消除",
    "update": "更新",
    "removeFile": "删除文件",
    "uploadFile": "上传文件",
    "pleaseChoosePreferedLanguage": "请选择您的首选语言",
    "edit": "编辑",
    "activate": "启用",
    "deactivate": "停用",
    "recievedOrders": "已收到订单",
    "chartRepresentation": "图表表示",
    "nameIsRequired": "姓名为必填项",
    "export": "出口",
    "noFilesAvailable": "没有可用的文件",
    "selectDepartmentToshowRoles": "选择一个部门以显示角色",
    "selectDepartmentWithActiveRoles": "选择具有活跃角色的部门",
    "nameCanContainOnlyAlphabets": "名称只能包含字母",
    "nameMustBeLessThan15Chars": "名称必须少于 30 个字符",
    "emailRequired": "电子邮件为必填项",
    "invalidEmailFormat": "电子邮件格式无效",
    "mobNumReq": "手机号码为必填项",
    "invalidMobFormat": "手机号码格式无效。",
    "passwordRequired": "密码是必需的",
    "departmentReq": "部门为必填项",
    "roleReq": "角色为必填项",
    "unableToUpdate": "无法更新",
    "orignalName": "原名",
    "uploadedDate": "上传日期",
    "fileName": "文件名",
    "importNum": "进口号码",
    "languagePreferences": "语言首选项",
    "pleaseTryAgainAfterSometime": "请稍后尝试",
    "noChanges": "没有变化",
    "nothingchanged": "没有改变",
    "pleaseChooseAnImageFile": "请选择图像文件",
    "fileIsTooBigSelectUnder1MB": "你的文件太大了！",
    "phoneShouldHave10Chars": "电话号码应有 10 个字符",
    "onlyCSVAllowed": "仅允许 CSV 文件",
    "loadingPleaseWait": "加载请稍候",
    "manager": "经理",
    "administrator": "行政人员",
    "Comingsoon": "即将推出",
    "totalAnimals": "动物总数",
    "receivedOrders": "已收到订单",
    "drugs": "药品",
    "detailedAnalysis": "详细分析",
    "barGraphRepOfActiveUsersAndDeactivateUsers": "活跃用户和非活跃用户的条形图表示",
    "barGraphRepOfRegAnimalsVsFarm": "登记动物与农场的条形图表示",
    "roleNumber": "角色编号",
    "roleName": "角色名称",
    "active": "积极的",
    "inactive": "不活跃",
    "admin": "行政",
    "addRole": "添加角色",
    "addRoles": "添加角色",
    "permissions": "权限",
    "sr": "先生。",
    "moduleName": "模块名称",
    "view": "看法",
    "deptNo": "部门编号",
    "selectByCategory": "按类别选择",
    "weeklyAnalytics": "每周分析",
    "pregnancy": "怀孕",
    "analytics": "分析",
    "calendar": "日历",
    "productName": "产品名称",
    "volumeSold": "销量",
    "recordPoints": "记录点",
    "inStock": "有存货",
    "revenue": "收入",
    "stockStatus": "库存状况",
    "barChart": "条形图",
    "lineChart": "折线图",
    "indexReturns": "指数回报",
    "chart": "图表",
    "time": "时间",
    "production": "生产",
    "customization": "定制化",
    "recordsPerPage": "每页记录数",
    "noDataAvailable": "无可用数据",
    "reporting": "报告",
    "optional": "选修的",
    "note": "笔记",
    "notes": "笔记",
    "date": "日期",
    "kG": "公斤",
    "weight": "重量",
    "type": "类型",
    "lessthan3Month": "<3个月",
    "lessthan6Month": "<6个月",
    "lessthan7Month": "<7个月",
    "lastWeek": "上星期",
    "thisWeek": "本星期",
    "lessthanOneYear": "<1年",
    "lessthanTwoYear": "<2年",
    "lessthanThreeYear": "<3年",
    "lessthanFourYear": "<4年",
    "yes": "是的",
    "no": "不",
    "of": "的",
    "notSpecified": "未指定",
    "days": "天",
    "day": "天",
    "aDay": "一天",
    "years": "年",
    "year": "年",
    "unit": "单元",
    "units": "单位",
    "to": "到",
    "profile": "轮廓",
    "logOut": "登出",
    "Unit": "单元",
    "otherSettings": "其他设置",
    "somethingWentWrong": "出了些问题。",
    "toDo": "去做",
    "loadingData": "加载数据中...",
    "taskNumber": "任务编号",
    "taskName": "任务名称",
    "startDate": "开始日期",
    "dueDate": "到期日",
    "reason": "原因",
    "quantity": "数量",
    "cost": "成本",
    "noRecordFound": "没有找到记录",
    "dailyUpdates": "每日更新",
    "weeklyUpdates": "每周更新",
    "moduleAccessed": "模块已访问",
    "typesOfAccess": "访问类型",
    "userId": "用户身份",
    "lastLogin": "上次登录",
    "terminalID": "终端ID",
    "geographicalAccessPoint": "地理接入点",
    "iPAddress": "IP地址",
    "fileAccessed": "文件已访问",
    "functionAccessed": "访问功能",
    "webPageURL": "网页网址",
    "accessType": "接入类型",
    "unsuccessfulLoginAttempts": "登录尝试失败",
    "customerAddress": "客户地址",
    "orderdate": "订购日期",
    "postageDate": "邮寄日期",
    "postID": "帖子ID",
    "packingTechnician": "包装技术员",
    "packingTechnicia": "包装技术",
    "packEdit": "包编辑",
    "batchNumber": "批号",
    "collectionTechnician": "采集技术员",
    "collectionTechnicia": "采集技术",
    "preparationTechnicia": "制备技术",
    "preparationTechnician": "准备技术员",
    "approvedManually": "手动批准",
    "researcher": "研究员",
    "dateOfApproval": "批准日期",
    "approvalEdit": "批准 编辑",
    "searchByAllExceptDate": "按除日期以外的所有内容搜索",
    "approval": "赞同",
    "collection": "收藏",
    "postage": "邮资",
    "pack": "盒",
    "straws": "吸管",
    "createdAt": "创建于",
    "sireID": "父系 ID",
    "economicIndexValue": "经济指数值",
    "latestCollectionDate": "最新领取日期",
    "locationId": "位置 ID",
    "lastUpdated": "最近更新时间",
    "print": "打印",
    "save": "节省",
    "tax": "税",
    "phoneNo": "电话号码",
    "exportAsPDF": "导出为 PDF",
    "statusUpdated": "状态已更新",
    "statusNotUpdated": "状态未更新",
    "inProgress": "进行中",
    "assignedTo": "分配给",
    "taskId": "任务编号",
    "createdDate": "创建日期",
    "numberOfAnimals": "动物数量",
    "healthRecordSubmittedSuccess": "健康记录提交成功",
    "healthRecordSubmitted": "已提交健康记录。",
    "InseminationRecordSubmittedSuccesful": "授精记录提交成功",
    "inseminationRecordSubmitted": "已提交授精记录。",
    "actionListDailyTask": "行动清单 - 每日任务",
    "sinceLastYear": "从去年开始",
    "sinceLastQuarter": "自上季度以来",
    "sinceLastMonth": "自上个月以来",
    "sinceLastWeek": "自从上周以来",
    "drugWithdrawPeriod": "停药期",
    "diagnosisName": "诊断名称",
    "animalWithNoGenetype": "该动物没有注册任何基因型数据。",
    "nameOfPreviousOwner": "前任所有者姓名",
    "avatarSize": "头像大小应小于 1 MB！",
    "testDestination": "测试目的地",
    "animalNotAdded": "未添加动物",
    "registerationSuccessful": "注册成功",
    "backToAnimalList": "返回动物列表",
    "addAnotherAnimal": "添加另一个动物",
    "animalDetailsUpdated": "动物详细信息更新成功",
    "animalUpdatedSuccessfully": "动物更新成功",
    "animalNotUpdated": "动物未更新",
    "notMember": "非会员？",
    "requestAccess": "申请进入",
    "typePassword": "请输入密码。",
    "minChars": "最少 6 个字符",
    "typeConfirmPassword": "输入确认密码",
    "passConfig": "密码确认不匹配。",
    "invalidEmailMobile": "电子邮件/手机格式无效",
    "passwordNotEmpty": "密码不能为空",
    "passwordLength": "密码长度不能少于8个字符",
    "cityVillage": "城市/乡村",
    "districtRegion": "地区/地区",
    "alreadyHaveAnAccount": "已有帐户？",
    "genetypeUpdated": "基因类型更新",
    "genetypeNotUpdated": "基因类型未更新",
    "sellTrade": "销售/贸易",
    "milkingDevon": "挤奶德文种畜出售",
    "detailedDescription": "详细说明",
    "longPara": "美国德文公牛队的小母牛和奶牛挤奶。",
    "contactSeller": "联系卖家",
    "enterListingTitle": "输入列表标题",
    "livestocktype": "牲畜类型",
    "uploadImage": "上传图片",
    "mobilePhone": "手机号码",
    "myLivestock": "我的牲畜",
    "livestockObservations": "牲畜观察",
    "selectFromRegisteredAnimals": "从注册动物列表中选择",
    "selectOption": "选择选项",
    "selectTypeObservation": "选择观察类型",
    "attachVeteinaryDocument": "附上兽医文件",
    "addsensorReading": "添加传感器读数",
    "myDocument": "我的文件",
    "enterAKeyword": "输入关键字",
    "documentType": "文件类型",
    "registerEditLivestock": "登记/编辑牲畜",
    "editLivestockProfile": "编辑牲畜资料",
    "copy": "复制",
    "dateOfRegister": "注册日期",
    "livestockType": "牲畜类型",
    "registerNewLivestock": "注册新牲畜",
    "enterUniqueTag": "输入唯一标签",
    "color": "颜色",
    "gender": "性别",
    "male": "男性",
    "female": "女性",
    "damm": "坝",
    "siree": "陛下",
    "dateOfSaleAuction": "出售/拍卖日期",
    "auctionRecord": "死亡名单拍卖记录",
    "distinguishingFeatures": "显着特征",
    "keywordListing": "关键字或列表 ID",
    "adType": "广告类型",
    "activeListingFund": "找到 1 条活跃列表",
    "setupSensors": "设置传感器",
    "serialNumber": "序列号",
    "sensorLocation": "传感器位置",
    "sensorType": "传感器类型",
    "installationDate": "安装日期",
    "ExpirationDate": "截止日期",
    "addGeo": "添加地理位置",
    "addMoreSensors": "添加更多传感器",
    "trackAndTrace": "追踪与追踪",
    "createNewShipment": "创建新货件",
    "workflowReference": "工作流程参考",
    "invoiceDate": "发票日期",
    "trackShipment": "追踪发货",
    "totalShipments": "总出货量",
    "activeShipment": "活跃出货量",
    "completedObjectives": "完成的目标",
    "processedPayments": "已处理的付款",
    "pointOfDestination": "目的地点",
    "sellerInformation": "卖家信息",
    "selectSellerConsignor": "选择卖家/发货人",
    "pointOfOrigin": "原点",
    "buyerInfo": "买家信息",
    "selectBuyerConsignor": "选择买家/发货人",
    "addSensorTriggers": "添加传感器触发器",
    "processPayments": "处理付款",
    "defineShippingContract": "定义运输合同",
    "addDigitize": "添加",
    "currentlyOnFarm": "目前在农场",
    "addSire": "添加父亲",
    "addApproval": "添加批准",
    "addCollection": "添加收藏",
    "addStraws": "添加吸管",
    "addPack": "添加包",
    "addPostage": "添加邮费",
    "searchBySire": "按先生搜索",
    "anyDataChangeMightBeLost": "任何数据更改都可能丢失",
    "wouldYouLikeToSaveOrWantToLeaveWithoutSaving": "您想要保存还是想不保存就离开",
    "leave": "离开",
    "stay": "停留",
    "animalFarm": "动物农场",
    "animalFarmH": "动物农场",
    "animalOrigin": "动物起源",
    "animalOriginH": "动物起源",
    "farmOfOrigin": "原产地农场",
    "farmOfOriginH": "原产地农场",
    "selectFarm": "选择农场",
    "searchFarm": "搜索农场",
    "confirmation": "确认",
    "proceed": "继续",
    "ok": "好的",
    "animal": {
      "tagH": "标签",
      "tagNumberH": "标签编号：您可以添加颜色和编号。",
      "goveRegNoH": "在政府组织注册时提供的号码",
      "birthWeightH": "犊牛出生体重",
      "birthEaseH": "牲畜的出生是一个自然过程，但有时可能会出现出生问题，大坝需要农民/牧民的帮助。",
      "birthFarmH": "动物来源/出生的农场。",
      "surrogateDamH": "母牛的 ID，其中植入来自供体雄性和供体雌性的受精卵以供其进一步发育。",
      "ownerH": "这是动物主人的名字。",
      "damH": "动物母本/母亲的 ID。",
      "sireH": "动物父/母的 ID。",
      "breedH": "品种是一组特定的家畜，具有同质的外观（表型）、同质的行为和/或其他区别于同一物种的其他生物的特征。",
      "conceptionMethodH": "动物是如何受孕的。",
      "genderH": "动物的性别。",
      "dobH": "动物的出生日期。",
      "operatorH": "填写该动物信息的人的姓名。",
      "removalFarmH": "动物移走农场 ",
      "dateOfRemovalH": "动物移走日期",
      "destinationOfRemoval": "被移走动物的目的地",
      "reasonOfRemovalH": "动物迁移的原因",
      "trackingNumberH": "动物被移除时分配给动物的编号",
      "brandH": "品牌——只是烧在牛身上的永久标记。",
      "tattoH": "动物身上的纹身。",
      "hornStatusH": "动物是否被去角。",
      "animalOriginH": "动物的原产国。",
      "previousOwnerH": "如果该动物是成年动物，则为该动物的前主人的名称。",
      "twinH": "该字段表示该动物是否有双胞胎。",
      "regBreedAssoNoH": "在品种协会/协会注册。",
      "breedAssoNameH": "动物注册的协会/社团名称",
      "breederH": "这是提供动物的组织的名称。",
      "breeder": "饲养员",
      "noteH": "关于动物的重要说明。",
      "accuracyWeight_for_field": "准确度重量",
      "conception": "概念",
      "addAnAnimal": "添加动物",
      "addAnimal": "添加动物",
      "registerAnAnimal": "注册动物",
      "uploadAnAnimal": "上传动物",
      "animalRegistration": "动物登记",
      "animalDetails": "动物详情",
      "tag": "标签",
      "tagNumber": "标签号码",
      "govtRegNumber": "政府。",
      "birthWeight": "出生体重（磅）",
      "birthEase": "分娩轻松",
      "birthFarm": "诞生农场",
      "surrogateDam": "代孕坝",
      "owner": "所有者",
      "ownershipType": "所有权类型",
      "animalDiseaseRecord": "动物疾病记录",
      "govtReg": "政府。",
      "regDate": "注册日期",
      "dam": "坝",
      "sire": "陛下",
      "heifer": "小母牛",
      "steer": "转向",
      "calf": "小牛",
      "farmHerd": "农场/畜群",
      "femaleCalf": "母牛犊",
      "maleCalf": "公牛犊",
      "newCalves": "新小牛队",
      "breed": "品种",
      "conceptionMethod": "受孕方法",
      "gender": "性别",
      "dateOfBirth": "出生日期",
      "operator": "操作员",
      "animalRemovedFarm": "动物移走农场",
      "dateOfAnimalRemoval": "动物移走日期",
      "destinationOfRemovedAnimal": "被移走动物的目的地",
      "reasonOfRemoval": "移除原因",
      "optionalAnimalInformation": "可选的动物信息",
      "animalPicture": "动物图片",
      "trackingNumber": "追踪号码",
      "brand": "品牌",
      "tatto": "纹身",
      "hornStatus": "喇叭状态",
      "animalOrigin": "动物起源",
      "previosOwner": "上一页 所有者",
      "twin": "双胞胎",
      "InABreedAssociation": "注册。",
      "nameOfBreedAssociations": "品种协会名称",
      "breedAssociations": "品种协会",
      "breederSupplier": "饲养员（供应商）",
      "importAnimal": "进口动物",
      "loadingAnimals": "正在加载动物...请稍候",
      "totalRegAnimals": "总注册量",
      "totalPregnantAnimals": "怀孕动物总数",
      "pregnantAnimalHistory": "怀孕动物的历史",
      "dailyAnimalPregnancyUpdates": "每日动物怀孕更新",
      "animalHistory": "动物史",
      "dailyAnimalUpdates": "每日动物更新",
      "totalPregnant": "总怀孕",
      "totalNewBorn": "新生儿总数",
      "searchByIDGOVRegTag": "按 ID、GOV 注册和标签搜索",
      "noANIMALAVAILABLE": "没有动物可用",
      "associationNumber": "协会编号",
      "associationName": "协会名称",
      "destinationName": "目的地名称",
      "plastic": "塑料",
      "metal": "金属",
      "naturalMating": "自然交配",
      "artificialInsemination": "人工授精",
      "embryoTransfer": "胚胎移植",
      "noAssistance": "没有帮助",
      "someAssistance": "一些帮助",
      "mechanicalAssistance": "机械协助",
      "aCesareanSection": "剖腹产",
      "abnormalDelivery": "异常交货",
      "male": "男性",
      "female": "女性",
      "castrated": "阉割的",
      "sale": "销售",
      "slaughter": "屠宰",
      "death": "死亡",
      "theft": "盗窃",
      "other": "其他",
      "horned": "有角的",
      "polled": "轮询",
      "dehorned": "去角",
      "details": "细节",
      "performance": "表现",
      "geneticWorth": "遗传价值",
      "healthRecord": "健康记录",
      "genotypeData": "基因型数据",
      "reminders": "提醒事项",
      "activityLog": "活动日志",
      "activityLogDetails": "活动日志详细信息",
      "editAnimal": "编辑动物",
      "familyInfo": "家庭信息",
      "breedInfo": "品种信息",
      "identification": "鉴别",
      "removalInfo": "搬家信息",
      "iDOfAnimalDam": "动物母亲的 ID。",
      "iDOfAnimalSire": "动物父亲的 ID。",
      "iDOfDamEmbryoUsed": "使用胚胎的母鼠的 ID。",
      "animalHasATwinOrNot": "该动物是否有双胞胎。",
      "breedType": "品种类型",
      "breedOfTheAnimal": "这是该动物的一个品种。",
      "regBreedAssociations": "在品种协会/协会注册。",
      "nameOfAssociationsSocieties": "动物注册的协会/社团名称。",
      "nameOfTheOrgSuppliedAnimal": "这是提供动物的组织的名称。",
      "countryOriginAnimal": "动物的原产国。",
      "birthFarmID": "出生农场 ID",
      "farmIDAnimalBorn": "动物出生的农场 ID。",
      "currentOwner": "现任所有者",
      "nameOfOwnerAnimal": "这是动物主人的名字。",
      "registrationDate": "注册日期",
      "previousOwner": "前任业主",
      "nameOfOperator": "操作者名称",
      "dateAnimalRemoved": "动物被移走的日期。",
      "destinationPlaceRemovedAnimal": "移走动物的目的地",
      "namePersonFillAnimalInformation": "填写该动物信息的人的姓名。",
      "reasonOfAnimalRemoval": "动物移走的原因",
      "reasonWhyTheAnimalIsRemoved": "动物被移走的原因",
      "processingDate": "处理日期",
      "DateInformationFilledChanged": "当前信息填写或更改的日期。",
      "animalID": "动物ID",
      "UniqueIdAnimal": "这是动物的唯一 ID。",
      "plasticTagNumber": "塑料标签号",
      "numberAnimalTag": "动物标签的编号。",
      "rFTagNumber": "射频标签号",
      "numberAnimalRFTag": "动物射频标签的编号。",
      "govtRegNumb": "政府。",
      "govtRegistrationNumber": "身份详细信息可能包括个人的姓名和地址、个人的流程服务代理、要执行的活动的地点以及个人提供的服务的描述。",
      "numberAssignedAnimalIsRemoved": "追踪号码是用于追踪动物活动的动物ID之一。",
      "dateOfAnimalRegistration": "动物登记日期",
      "stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal": "品牌——只是烧在牛身上的永久标记。",
      "tattoOnAnimal": "动物身上的纹身。",
      "whetherTheAnimalIsDehorned": "动物是否被去角。",
      "milkingAnimals": "挤奶动物",
      "studAnimals": "种马动物",
      "animalInseminationRecord": "动物授精记录",
      "numOfStrawsOrdered": "订购吸管数量",
      "totalNumOfStraws": "吸管总数",
      "strawId": "吸管编号",
      "addSireAutomation": "添加父亲自动化",
      "addApprovalAutomation": "添加审批自动化",
      "addCollectionAutomation": "添加收集自动化",
      "addStrawsAutomation": "添加吸管自动化",
      "addPackAutomation": "添加包装自动化",
      "addPostageAutomation": "添加邮资自动化",
      "searchBySire": "按先生搜索",
      "numberOfProgenies": "后代数量",
      "sireEdit": "父亲 编辑",
      "searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId": "按吸管 ID、吸管总数、批次号和位置 ID 搜索",
      "searchByPackIdNumberOfStrawsOrderedPackingTechnicia": "按包装 ID、订购吸管数量、包装技术搜索",
      "searchByCollectionAndPreparationTechnicia": "按收集和制备技术搜索",
      "registerSemenAutomation": "注册精液自动化",
      "addSemenAutomation": "添加精液自动化",
      "strawAutomationRegistered": "秸秆自动化注册",
      "strawAutomationRegisteredNotRegistered": "秸秆自动化 已注册 未注册",
      "sireAutomationRegistered": "赛尔自动化注册",
      "sireAutomationNotRegistered": "赛尔自动化未注册",
      "postageAutomationIsRegistered": "邮资自动化已注册",
      "postageAutomationNotRegistered": "邮资自动化未注册",
      "packAutomationIsRegistered": "包装自动化已注册",
      "packAutomationNotRegistered": "包装自动化未注册",
      "postageAutomationIsUpdated": "邮资自动化已更新",
      "postageAutomationNotUpdated": "邮资自动化未更新",
      "packAutomationIsUpadted": "包装自动化已更新",
      "packAutomationNotUpadted": "包装自动化未更新",
      "collectionAutomationUpdated": "收集自动化已更新",
      "collectionAutomationNotUpdated": "收集自动化未更新",
      "approvalAutomationIsUpdated": "审批自动化已更新",
      "approvalAutomationIsNotUpdated": "审批自动化未更新",
      "collectionAutomationRegistered": "收集自动化注册",
      "collectionAutomationNotRegistered": "收集自动化未注册",
      "approvalAutomationIsRegistered": "批准自动化已注册",
      "approvalAutomationIsNotRegistered": "审批自动化未注册",
      "strawAutomationUpdated": "秸秆自动化更新",
      "strawAutomationIsNotUpdated": "吸管自动化未更新",
      "searchSire": "搜寻陛下",
      "strawsEdit": "吸管 编辑",
      "nextAnimals": "下一个动物",
      "performanceInfo": {
        "milk": "牛奶",
        "liveweight": "活重",
        "score": "分数",
        "fertility": "生育能力",
        "measurements": "测量",
        "dailyProteinYield": "每日蛋白质产量",
        "amountProteinMilkCowDay": "特定日期从奶牛获得的牛奶中的蛋白质含量。",
        "dailyMilkYield": "日产奶量",
        "volumeMilkCowDay": "在特定日期从特定奶牛获得的牛奶量。",
        "dailyFatYield": "每日脂肪产量",
        "amountFatMilkCowDay": "特定日期从奶牛获得的牛奶中的脂肪量。",
        "dailyProteinContent": "每日蛋白质含量",
        "dailyFatContent": "每日脂肪含量",
        "milkLactose": "牛奶乳糖",
        "amountLactoseMilk": "牛奶中乳糖的含量。",
        "milkUrea": "乳尿素",
        "indicatorAmountCrudeProtein": "奶牛日粮中粗蛋白含量的指标",
        "lactationNumber": "哺乳期数",
        "ordinalNumLactation": "哺乳期的序数。",
        "lengthOfLactation": "哺乳期长度（例如 23 天）",
        "lactationLength": "哺乳期长度",
        "milkingFrequency": "挤奶频率",
        "frequcnyOfMilking": "挤奶频率（例如2次/天）",
        "liveWeightInformation": "体重信息",
        "currentWeight": "目前的体重",
        "weightAnimal": "动物的重量。",
        "postWeaningGain": "断奶后增益",
        "dailyGainInAnimalWeightWeaning": "断奶后动物体重的每日增加。",
        "weaningWeight": "断奶体重",
        "weightAnimalMeasuredWeaning": "断奶当天测量的动物体重。",
        "averageDailyGain": "平均日增重",
        "averageAmountWeightAnimalGainFeedingPeriod": "动物在喂养期间每天平均增加的体重",
        "carcassWeight": "胴体重量",
        "weightAnimalsHideInternalOrgansRemoved": "去除头部、皮毛和内脏后动物的重量。",
        "weightAtCalving": "产犊时体重",
        "weightAtTheTimeOfCalving": "产犊时的体重。",
        "yearlingWeight": "一岁体重",
        "weightYearOldAnimal": "一岁动物的重量。",
        "somaticCellScore": "体细胞评分",
        "somaticCellScoreIndicatorMastitis": "体细胞评分作为乳腺炎的指标。",
        "lastUpdate": "最后更新",
        "bodyConditionScore": "身体状况评分",
        "scoreAnimalFat": "根据脂肪的多少来划分动物的分数。 ",
        "teatScore": "乳头评分",
        "scoreMeasureingShapeTeats": "乳头尺寸分数是对乳头长度和周长的主观评估，范围从 9（非常小）到 1（非常大）。",
        "udderScore": "乳房悬吊评分",
        "scoreMeasureingShapeOfUdder": "测量乳房形状的分数（1-9 分）。",
        "whetherAnimalEasyBirthDifficult": "牲畜的出生是一个自然过程，但有时可能会出现出生问题，大坝需要农民/牧民的帮助。",
        "totalLongevity": "总寿命",
        "survivalLactationTraitCowCulledBreeding": "第 1 次至第 5 次哺乳期的存活率。",
        "docility": "温顺",
        "circumferenceBullScrotal": "公牛阴囊周长",
        "intervalSuccessInsemination": "从第一次到成功授精的时间间隔。",
        "ageAtFirstCalving": "首次产犊年龄",
        "ageCowCalving": "母牛第一次产犊的年龄是多少？",
        "calvingInterval": "产犊间隔",
        "periodCalving": "从一次产犊到下一次产犊的时期。",
        "scrotalCircumference": "阴囊周长",
        "estrusDetection": "发情检测",
        "trackingBehaviorAnimalDetectingEstrus": "跟踪动物的运动行为以检测奶牛的发情期。",
        "presenceOfEstrus": "发情期的存在",
        "isCowInEstrusStage": "是指奶牛处于发情期或非发情期",
        "matureWeight": "成熟体重",
        "weightAnimalDefinedAge": "特定年龄动物的体重。",
        "matureHeight": "成熟身高",
        "heightAnimalDefinedAge": "特定年龄动物的身高。",
        "footClawSet": "脚爪套装",
        "shapeAnimalClaw": "动物爪子的形状。",
        "pulmonaryArterialPressure": "肺动脉压",
        "animalBloodPreasure": "动物的血压。",
        "footAngle": "脚角",
        "shapeAnimalFoot": "动物脚的形状。",
        "ribEyeArea": "肋眼区域",
        "amountRibEyeArea": "肋眼区域的数量。",
        "ultrasoundFat": "超声波脂肪",
        "measureFatAmount": "脂肪量的测量。",
        "ultrasoundIntramuscularFat": "超声波肌内脂肪",
        "ultrasoundRibEyeArea": "超声波肋眼区",
        "measureRibeyeArea": "测量肋眼面积。",
        "fatThickness": "脂肪厚度",
        "amountAnimalBackFat": "动物背部脂肪的量。",
        "marbling": "大理石花纹",
        "marballingMeasurement": "大理石花纹是积累在肌肉内和肌纤维束之间的可见的不饱和（健康）肌内脂肪。",
        "dryMatterIntake": "干物质摄入量",
        "amountFeedAnimalConsumesAMoisture": "动物每天消耗的不含水分的饲料量。"
      },
      "feedsName": "提要名称",
      "feedName": "饲料名称",
      "firstFeedQuantity": "首次进料量",
      "additionalFeed": "额外饲料",
      "cloversRyeGrasses": "三叶草、黑麦草",
      "greenFodderHayLegumes": "青饲料、干草、豆类",
      "feedsRegisteredSuccessfully": "订阅源注册成功",
      "feedsNotRegistered": "提要未注册",
      "fEEDQUANTITY": "饲料量",
      "feedQuantity": "饲料量",
      "fEEDNAME": "提要名称",
      "nOFEEDINFOAVAILABLE": "没有可用的 Feed 信息",
      "searchByFeedName": "按 Feed 名称搜索",
      "loadingFeedInfo": "正在加载供稿信息...请稍候",
      "todayFeedInfo": "今日饲料信息",
      "feedInfo": "饲料信息",
      "loremIpsumDolorSitAmet": "Lorem ipsum dolor sat amet，consectetur adipiscing elit。 ",
      "geneticWorthInfo": {
        "breedingValueEconomicIndex": "该育种值是否用于经济指标的计算。",
        "dailyProteinYieldUsed": "每日蛋白质产量",
        "weightAssignedBreedingDailyProteinYield": "分配给与“每日蛋白质产量”相对应的育种值的权重。",
        "dailyProteinYieldWeight": "每日蛋白质产量 重量",
        "rankAnimalInRelationshipEconomicIndex": "动物的排名与经济指数的关系。",
        "economicIndexRank": "经济指数排名",
        "percentileEconomicIndexFall": "经济指数所处的百分位。",
        "economicIndexPercentile": "经济指数百分位",
        "accuracyOfEconomicIndex": "经济指标的准确性。",
        "economicIndexAccuracy": "经济指数准确性",
        "weightedAverageOfBreedingValues": "育种值的加权平均值。",
        "economicIndex": "经济指数",
        "rankOfAnimalInRelationshipBreeding": "动物的等级与相应的育种值的关系。",
        "dailyProteinYieldBreedingValueRank": "日蛋白产量育种值排名 ",
        "percentileBreedingFalls": "育种价值所在的百分位。",
        "dailyProteinYieldBreedingPercentile": "每日蛋白质产量育种值百分位 ",
        "accuracyEstimatedBreeding": "估计育种值的准确性。",
        "dailyProteinYieldBreedingAccuracy": "每日蛋白质产量育种值准确度",
        "estimatedBreedingTraitDailyProteinYield": "性状“每日蛋白质产量”的估计育种价值。",
        "dailyProteinYieldBreedingValue": "每日蛋白质产量育种值 ",
        "pathToTheDirectoryScriptsBreeding": "硬盘上包含用于计算育种值的脚本的目录路径。",
        "scriptsPath": "脚本路径",
        "softwarePackageBreeding": "用于计算育种值的软件包。",
        "breedingValueSoftware": "育种价值软件",
        "methodCalculateBreeding": "育种计算方法",
        "breedingValueMethod": "育种值法",
        "trait": "特征",
        "tools": "工具",
        "geneticWorth": "遗传价值",
        "dailyProteinYield": "每日蛋白质产量",
        "breedingValue": "育种价值",
        "breedingValueBIFAccuracy": "育种值 BIF 准确度",
        "breedingValuePercentile": "育种价值百分位",
        "breedingValueRank": "育种价值排名",
        "checkLTD": "支票有限公司",
        "ultrasoundDiagnostic": "超声诊断",
        "selectYieldUsed": "选择已用产量",
        "softwareName": "软件名称",
        "animalGenWorthUpdatedSuccessfully": "动物创世价值更新成功"
      },
      "addNote": "添加注释",
      "enterNote": "输入备注",
      "noteIsRequired": "备注为必填项",
      "noteMustBeLessThan50Characters": "注释必须少于 50 个字符",
      "noteAdded": "添加注释",
      "noteNotAdded": "注释未添加",
      "noteForAnimal": "动物注意事项。",
      "noNoteFoundForThisAnimal": "没有找到关于这种动物的注释。",
      "inseminationData": "授精数据",
      "nameOfInseminator": "授精者姓名",
      "activity": "活动",
      "searchByNameActivity": "按名称、活动搜索",
      "searchByTaskNameNumber": "按任务名称、编号搜索",
      "inseminationDate": "授精日期",
      "genotypeDataInfo": {
        "genotypeAnimalID": "基因型动物 ID",
        "iDTubeBloodSampleAnimalNumberGenotypingService": "这是装有从动物或一些基因分型服务中采集的血液样本的试管的 ID",
        "geneticTechnicianName": "基因技术员姓名",
        "NameTechnicianBloodSamplesAnimal": "这是从动物身上采集血液样本的技术人员的名字",
        "sNPData": "单核苷酸多态性数据",
        "genotypingServiceNote": "基因分型服务说明",
        "InfoGenotypingGenotypingTechnology": "与基因分型相关的所有信息，例如基因分型公司名称、使用的基因分型技术、基因分型日期等",
        "numberOfSNPs": "SNP 数量",
        "numberOfSNPsAnimalGenotyped": "动物基因分型的 SNP 数量",
        "nameOfTheDrug": "药品名称",
        "animalGenoDataUpdatedSuccessfully": "动物基因数据更新成功",
        "animalGenoDataNotUpdated": "动物基因数据未更新",
        "animalIDIsRequired": "需要动物 ID",
        "techNameIsRequired": "技术。",
        "onlyAlphabetsAreAllowed": "只允许使用字母",
        "genoDataIsRequired": "需要基因数据",
        "serviceNoteIsRequired": "需要服务备注",
        "sNPIsRequired": "需要 SNP"
      },
      "healthRecordInfo": {
        "treatment": "治疗",
        "treatmentTakenAnimal": "对动物采取了什么治疗。",
        "reasonOfTreatment": "治疗原因",
        "reasonForTreatment": "治疗原因",
        "whatReasonOfTreatment": "是什么原因治疗。",
        "treatmentDate": "治疗日期",
        "dateOfTreatment": "治疗日期。",
        "diagnosis": "诊断",
        "nameDiagnosedDiseaseConditionSymptoms": "诊断的疾病/病症名称或主要症状",
        "drugID": "药品编号",
        "iDOfDrugWhichIsGivenToAnimal": "给予动物的药物 ID。",
        "drugName": "药品名称",
        "nameDrugAnimal": "给予动物的药物名称。",
        "drugWithdrawalPeriod": "停药期",
        "timeAdministrationDrugAnimalMeatMilkHumanConsumption": "对动物给药后确保人类食用肉或奶的安全所需的时间",
        "attendingVeterinarian": "主治兽医",
        "qualifiedPersonCaseAnimal": "见过案件/动物的合格人员",
        "packID": "包编号",
        "iDPackTreatment": "用于治疗的包的ID",
        "veterinarianName": "兽医姓名",
        "animalNoHealthRecord": "该动物没有任何健康记录。",
        "addHealthRecord": "添加健康记录",
        "healthStatus": "健康状况",
        "loadingDiseasesPleaseWait": "正在加载疾病...请稍候",
        "animalDiseaseRecord": "动物疾病记录",
        "animalHealthRecord": "动物健康记录",
        "animalTreatmentRecord": "动物治疗记录",
        "loadingHealthData": "正在加载健康数据...",
        "healthRecord": "健康记录",
        "nameOfDiagnosis": "诊断名称",
        "treatmentName": "治疗名称",
        "drugGivenBy": "药物给予者",
        "recessiveDiseases": "隐性疾病",
        "recessiveDiseasesMessage": "这头公牛携带哪种隐性疾病等位基因"
      },
      "conceptionInfo": {
        "addNewConception": "添加新概念",
        "semenEmbryo": "精液/胚胎",
        "pregnancyCheck": "怀孕检查",
        "birthInfo": "出生信息",
        "searchByInseminatorOrganisationBreedingConception": "按授精者名称、组织名称、育种服务编号、受孕方法搜索",
        "deliveryDate": "交货日期",
        "calfId": "小牛 ID",
        "birthDayOldWeight": "出生（日龄）体重",
        "searchByBirthEase": "按出生难易程度搜索",
        "searchPregnancyCheckOperatorMethod": "按怀孕检查运营商、怀孕检查方法搜索",
        "pregnancyCheckDate": "怀孕检查日期",
        "conceptionSuccess": "受孕成功",
        "pregnancyCheckOperator": "怀孕检查操作员",
        "pregnancyCheckMethod": "怀孕检查方法",
        "recentlyPregnant": "最近怀孕了",
        "pregnancyConfirmationDate": "确认怀孕日期",
        "pregnancyRate": "怀孕率",
        "timePeriodOfPregnancy": "怀孕时间",
        "semenProduction": "精液生产",
        "embryoProduction": "胚胎生产",
        "semen": "精液",
        "embryoTransferDate": "胚胎移植日期",
        "daysOfPregnancy": "怀孕天数",
        "searchSireEmbryoSurrogate": "按父系 ID、胚胎组织名称、代孕母犬品种搜索",
        "selectDate": "选择日期",
        "orgnisationNameContainNumber": "组织名称不应包含数字",
        "selectBirthEase": "选择轻松分娩",
        "selectUnit": "请选择单位",
        "animalConceptionAddedSuccessfully": "动物受孕添加成功",
        "postageCustomerName": "邮费客户名称",
        "searchByPostageCustNameCustAddPostId": "按邮资客户姓名、客户地址、邮政 ID 搜索",
        "dateOfSemenCollection": "精液采集日期",
        "dateOfSemenPreparation": "精液准备日期",
        "semenMotility": "精液活力",
        "semenConcentration": "精液浓度",
        "postageEdit": "邮费编辑",
        "enterSireId": "输入父辈 ID",
        "selectEmbryoOrganisation": "选择胚胎组织",
        "matingDateH": "受孕日期，自然交配或人工授精。",
        "inseminatorNameH": "进行授精过程的人员（兽医/技术员）",
        "orgNameH": "为人工智能提供精液吸管的组织或公司名称",
        "brServiceNumH": "记录繁殖次数（例如第 1 次、第 2 次或第 3 次）",
        "conceptionMethodH": "动物受孕的方式是怀孕的开始，其标志是精子使卵子受精。",
        "sireIdH": "动物父/母的 ID",
        "damIdH": "动物母本/母亲的 ID。",
        "sarogatedDamH": "母牛的 ID，其中植入来自供体雄性和供体雌性的受精卵以供其进一步发育。",
        "embOrgNameH": "胚胎的组织名称",
        "sarogateDamBreedH": "代孕品种的日期",
        "sireBreedH": "父系品种的类型（婆罗门、博兰）",
        "pregCheckDateH": "通过超声波和血液检测，最早可以在 30 天检测到奶牛怀孕。要利用触诊方法确定奶牛是否怀孕，奶牛通常需要至少怀孕 35-50 天。",
        "conceptionSuccessH": " 牛的受精率为 90%，平均产犊率为 55% 左右，表明胚胎-胎儿死亡率约为 35%（Diskin 等，2006）。",
        "pregnancyCheckOperatorH": "兽医和专业动物技术人员最常向农民提供这些服务。",
        "pregnancyCheckMethodH": "牛妊娠诊断最常用的两种方法是生殖道手动触诊（经直肠）和生殖道经直肠超声检查",
        "deliveryDateH": "分娩发生的日期",
        "calfIdH": "新生牛犊身份证",
        "birthEaseH": "牲畜的出生是一个自然过程，但有时可能会出现出生问题，大坝需要农民/牧民的帮助。",
        "birthDayOldWeightH": "动物出生当天的重量或一日龄鸟类的重量",
        "customerAddress": "客户地址"
      },
      "all": "全部",
      "ungrouped": "未分组的动物",
      "active": "分组动物",
      "updateAnimal": "更新动物"
    },
    "dashboardS": {
      "dailyActivities": "日常活动",
      "pendingTasks": "待处理任务",
      "performanceOfGeno": "基因型的表现",
      "breed": "品种",
      "chromosome": "染色体",
      "seqChange": "顺序改变",
      "inheritance": "遗产",
      "diseaseName": "疾病名称",
      "refSequence": "参考序列",
      "pubmedRef": "出版参考文献",
      "matingDate": "交配日期",
      "inseminatorName": "授精者姓名",
      "orgName": "机构名称",
      "brServiceNum": "育种服务号码",
      "conceptionMethod": "受孕方法",
      "semEmbInfo": "精液/胚胎信息",
      "sireId": "父系 ID",
      "damID": "大坝编号",
      "srgDamId": "替代母坝 ID",
      "embOrgName": "胚胎组织。",
      "srgDamBreed": "代孕母猪品种",
      "sireBreed": "父系品种",
      "damBreed": "大坝品种"
    },
    "user": {
      "selectLanguage": "选择语言",
      "unitPreference": "单位偏好",
      "selectUnitOfMeasure": "选择测量单位",
      "importedUser": "导入用户",
      "impFileStatus": "导入文件状态",
      "loadingUser": "正在加载用户...请稍候",
      "totalUsers": "用户总数",
      "pendingUsers": "待定用户",
      "changePassword": "更改密码",
      "goodIdeaToUsePassword": "最好使用您在其他地方未使用过的强密码。",
      "enterCurrentPassword": "输入当前密码",
      "enterNewPassword": "输入新密码",
      "reEnterPassword": "重新输入新的密码",
      "enterPassword": "输入密码",
      "repeatNewPassword": "重复新密码",
      "emailAddr": "电子邮件地址",
      "enterYourPhoneNumber": "输入你的电话号码",
      "pleaseTypeOldPassword": "请输入旧密码。",
      "pleaseTypeNewPassword": "请输入新密码。",
      "pleaseTypeConfirmPassword": "请输入确认密码。",
      "passwordChangedSuccesFully": "密码修改成功",
      "currentPassword": "当前密码",
      "newPassword": "新密码",
      "passwordDoesNotMatch": "密码不匹配。",
      "emailCanNotBeEmpty": "邮箱不能为空",
      "profileUpdated": "个人资料已更新",
      "profileNotUpdated": "个人资料未更新",
      "unableToVerifyEmail": "无法验证电子邮件",
      "otpSentOnEmail": "OTP 通过电子邮件发送",
      "otpSentSuccessFully": "OTP 发送成功",
      "importUsers": "导入用户",
      "imageUpdated": "图片已更新",
      "departmentName": "部门名称",
      "departmentNum": "部门编号",
      "departmentAdded": "添加部门",
      "departmentNotAdded": "未添加部门",
      "searchDepartnment": "按部门名称或编号搜索",
      "addDepartMent": "添加部门",
      "addDepartment": "添加部门",
      "roleNameIsRequired": "角色名称为必填项",
      "roleNameMustBeLessThan15Chars": "角色名称必须少于 15 个字符",
      "roleAdded": "添加角色",
      "editDepartment": "编辑部门",
      "departmentUpdated": "部门更新",
      "departmentNotUpdated": "部门未更新",
      "deleteDepartment": "删除部门",
      "deleteDepartmentMessage": "您确定要删除该部门吗？",
      "noRoleAvailable": "没有可用的角色",
      "roleUpdated": "角色更新",
      "roleNotUpdated": "角色未更新",
      "editRole": "编辑角色",
      "allRole": "所有角色",
      "addNewRole": "添加新角色",
      "allDepartment": "所有部门",
      "permissionsUpdated": "权限已更新",
      "permissionsnotUpdated": "权限未更新",
      "roleNo": "角色编号",
      "searchByEmailAndName": "按电子邮件和姓名搜索",
      "userID": "用户身份",
      "userUpdated": "用户更新",
      "userNotUpdated": "用户未更新",
      "userAdded": "用户已添加",
      "userNotAdded": "用户未添加",
      "activateUser": "激活用户",
      "deactivateUser": "停用用户",
      "userStatusMsg": "您确定要更改用户状态吗",
      "countryRequired": "国家/地区为必填项",
      "stateRequired": "状态为必填项",
      "cityRequired": "城市为必填项",
      "searchByRole": "按角色编号、角色名称、部门搜索",
      "noModuleAvailable": "无可用模块",
      "searchBYModuleName": "按模块名称搜索"
    },
    "farm": {
      "farmID": "农场 ID",
      "onTheFarm": "在农场",
      "userRoles": "用户角色",
      "adduser": "添加用户",
      "addAuser": "添加用户",
      "uploadUsers": "上传用户",
      "addNewUser": "添加新用户",
      "selectDept": "选择部门",
      "selectRole": "选择角色",
      "editUser": "编辑用户",
      "totalFarms": "农场总数",
      "NoAnimalsRegisteredForthisFarm": "该农场没有登记任何动物",
      "farmsPerPage": "每页农场数",
      "regularFarms": "常规农场",
      "farmRegisteredProducts": "农场注册产品",
      "searchByFarmNameAndId": "按农场名称和 ID 搜索",
      "loadingProductsPleaseWait": "正在加载产品...请稍候",
      "farmName": "农场名称",
      "farmLocation": "农场位置",
      "productName": "产品名称",
      "stockStatus": "库存状况",
      "inStock": "有存货",
      "searchByProductName": "按产品名称搜索",
      "productCategory": "产品分类",
      "products": "产品",
      "farms": "农场",
      "registerAfarm": "注册农场",
      "govtRegistry": "政府。",
      "cooperativeID": "合作ID",
      "farmType": "农场类型",
      "contractMating": "合约配对",
      "customization": "定制化",
      "recordsPerpage": "每页记录数",
      "restoreDefault": "恢复默认",
      "apply": "申请",
      "searchState": "按农场 ID、政府登记处、合作社 ID、农场类型、合同配对进行搜索",
      "farmOwner": "农场主",
      "govRegistrationNo": "政府注册号",
      "farmInformation": "农场信息",
      "ownershipType": "所有权类型",
      "communityName": "社区名字",
      "farmLicenseInformation": "农场许可证信息",
      "licenseNumber": "许可证号",
      "licenseExpiryDate": "许可证到期日期",
      "regulatorName": "监管机构名称",
      "regulatorRepresentativeName": "监管机构代表姓名",
      "farmLocationSize": "农场位置",
      "productionSystem": "生产体系",
      "country": "国家",
      "state": "状态",
      "city": "城市",
      "street": "街道",
      "houseNumber": "门牌号码",
      "farmRegistration": "农场登记",
      "cancel": "取消",
      "register": "登记",
      "ok": "好的",
      "totalFarmSize": "农场总规模",
      "farmGeographicLocation": "农场地理位置",
      "perimeterPointLongitude": "周界点经度",
      "perimeterPointLatitude": "周边点纬度",
      "perimeterPointLabel": "周边点标签",
      "perimeterLength": "周长",
      "farmLatitude": "农场纬度",
      "farmLongitude": "农场经度",
      "editFarm": "编辑农场",
      "update": "更新",
      "editAfarm": "编辑农场",
      "nextFarm": "下一个农场",
      "nameoftheFarm": "农场名称",
      "registerAProduct": " 注册产品",
      "farmProducts": "农产品",
      "calf": "小牛",
      "steer": "转向",
      "heifer": "小母牛",
      "sire": "陛下",
      "dam": "坝",
      "registerAnAnimal": "注册动物",
      "farmAnimals": "农场动物",
      "farm_type": "农场型",
      "farm_Owner": "农场主",
      "dateOfRegistration": "注册日期",
      "dataIsNotAvailableForThisFarm": "该农场没有可用数据",
      "registerNewProduct": "注册新产品",
      "information": "信息",
      "licenseInfo": "许可证信息",
      "locationInfo": "位置信息",
      "geoLocation": "地理位置",
      "perimeterLengthState": "农场周长（栅栏长度）",
      "totalFarmSizeState": "农场的规模",
      "productionSystemState": "农场使用的生产系统",
      "contractMatingState": "农场参与的合同配对计划代码。",
      "ownershipTypeState": "所有权类型",
      "regulatorRepresentativeNameState": "代表监管机构发放许可证的人员姓名",
      "regulatorNameState": "颁发许可证的监管机构名称",
      "licenseExpiryDateState": "当前许可证到期的日期",
      "licenseNumberState": "监管机构发布的许可证号",
      "plotNumberState": "农场的门牌号。",
      "plotNumber": "房屋/地块号码",
      "streetStatement": "农场的街道名称。",
      "cityStatement": "农场所在的城市。",
      "stateStatement": "农场所在国家的地区。",
      "countryState": "农场所在的国家。",
      "perimeterPointLongitudeState": "农场上一点的经度。",
      "perimeterPointLatitudeState": "农场上一点的纬度。",
      "perimeterPointLabelState": "点的标签。",
      "farmLongitudeState": "农场的经度。",
      "farmLatitudeState": "农场的纬度。",
      "farmNameH": "农场名称",
      "farmTypeH": "进行不同活动的农场类型。",
      "farmOwnerH": "农场所有者姓名（自动生成农民姓名输入信息）",
      "ownershipTypeH": "拥有/控制其耕种土地的农民类型和不拥有/控制土地的农民类型。",
      "govtRegNumbH": "监管机构分配的农场登记号",
      "contractMatingH": "农场参与的合同交配计划代码",
      "productionSystemH": "农场使用什么生产系统",
      "cooperativeIDH": "农场所属合作社的 ID ",
      "licenseNumberH": "监管机构发布的许可证上的识别号，用于识别所有者的身份。",
      "licenseExpiryDateH": "当前许可证到期的日期",
      "regularNameH": "颁发许可证的监管机构名称",
      "regularRepName": "代表监管机构发放许可证的人员姓名",
      "countryH": "农场所在的国家。",
      "stateH": "农场所在国家的地区。",
      "cityH": "农场所在的城市。",
      "streetH": "农场的街道名称。",
      "houseNumberH": "农场的门牌号。",
      "totalFarmSizeH": "农场规模是指农场目前耕种的土​​地总和，包括休耕土地，但不包括自然植被、树木或牧场的土地。",
      "farmLatitudeH": "是赤道以北或以南距离的测量。",
      "farmLongitudeH": "它测量本初子午线以东或以西的距离。",
      "perimeterLengthH": "农场周长（围栏长度）",
      "perimeterPointLabelH": "点的标签。",
      "perimeterPointLatH": "农场上一点的纬度",
      "perimeterPointLongH": "农场上一点的经度",
      "noProductAvailable": "无可用产品",
      "farmUpdated": "农场更新",
      "performance": "表现",
      "milkInformation": "牛奶信息",
      "farmNameRequired": "农场名称为必填项"
    },
    "login": {
      "welcome": "欢迎！",
      "welInfo": "输入您的凭据。",
      "login": "登录",
      "forgotPassword": "忘记密码",
      "forgotPasswordDesc": "请输入您的帐户关联的电子邮件地址。",
      "backToLogin": "回到登入"
    },
    "actionListmod": {
      "actionList": "行动清单",
      "tODAY": "今天",
      "createTask": "创建任务",
      "myActivities": "我的活动",
      "jhonSmith": "约翰·史密斯",
      "farmID": "农场 ID",
      "dateOfEvent": "活动日期",
      "actionRequired": "需要采取的行动",
      "actionTaken": "所采取的行动",
      "animalEventID": "动物事件 ID",
      "cANCEL": "取消",
      "cONFIRM": "确认",
      "sTATEMENT": "您确定要删除此记录吗？",
      "dAY": "天",
      "wEEK": "星期",
      "mONTH": "月",
      "sUBMIT": "提交",
      "startDate": "开始日期",
      "endDate": "结束日期",
      "rEPEAT": "重复",
      "taskCategory": "任务类别",
      "pRIORITY": "优先事项",
      "aSSIGNEE": "受让人",
      "selectLocation": "选择地点",
      "selectAnimals": "选择一只或多只动物",
      "dESCRIPTION": "描述",
      "customRecurrence": "自定义重复",
      "repeatEvery": "重复每个",
      "taskName": "任务名称",
      "enterDescription": "输入描述",
      "toDo": "去做",
      "assignTo": "分配给",
      "status": "地位",
      "nOTE": "笔记",
      "noTaskAvailable": "没有可用的任务",
      "healthRecord": "健康记录",
      "iD": "ID",
      "tAG": "标签",
      "dateOfbirth": "出生日期",
      "taskTakenat": "任务执行时间",
      "gENDER": "性别",
      "bREED": "品种",
      "regDate": "注册。",
      "updateHealthRecord": "更新动物健康记录",
      "treatment": "治疗",
      "reasonOftreatment": "治疗原因",
      "treatmentDate": "治疗日期",
      "dIAGNOSIS": "诊断",
      "drugId": "药品编号",
      "drugName": "药品名称",
      "drugWithdrawalperiod": "停药期",
      "attendingVeterinarian": "主治兽医",
      "packId": "包编号",
      "noItemsselected": "未选择任何项目",
      "healthRecordsubmission": "提交健康记录",
      "inseminationRecordsubmission": "授精记录提交",
      "inseminatorName": "授精者姓名",
      "inseminatorId": "授精者 ID",
      "conceptionRate": "受孕率",
      "dateOfmeasurement": "测量日期",
      "recordSubmission": "记录提交",
      "uPDATE": "更新",
      "updateTask": "更新任务"
    },
    "inseminatorStatisticsInfo": {
      "addInseminatorInfo": "添加授精者信息",
      "inseminatorNumber": "授精器编号",
      "loadingInseminatorPleaseWait": "正在加载授精器...请稍候",
      "searchByIDAndName": "按 ID 和姓名搜索",
      "inseminatorInfoAdded": "添加授精者信息",
      "inseminatorInfoNotAdded": "未添加授精者信息",
      "inseminatorInfoUpdated": "授精信息已更新",
      "inseminatorInfoNotUpdated": "授精信息未更新",
      "editAInseminatorInfo": "编辑授精者信息",
      "inseminatorList": "授精者名单",
      "inseminatorInfoDetails": "授精者信息详情",
      "updateInseminatorInfo": "更新授精者信息"
    },
    "organizationNtrInfo": {
      "loadingOrdersPleaseWait": "正在加载订单...请稍候",
      "addStocks": "添加股票",
      "addStock": "添加库存",
      "quantity": "数量",
      "selectUnit": "选择单位",
      "farmProducts": "农产品",
      "cost": "成本",
      "transactionID": "交易ID",
      "recipientID": "收件人 ID",
      "orderID": "订单号",
      "recepientName": "收件人姓名",
      "createAOrder": "创建订单",
      "totalStocks": "总库存",
      "orders": "命令",
      "totalPending": "待处理总数",
      "totalDelivered": "总交付量",
      "searchByRecepientNameOrderIdRecepientId": "按收件人姓名、订单 ID、收件人 ID 搜索",
      "chooseTheDate": "选择日期",
      "transactionDate": "交易日期",
      "selectCategory": "选择类别",
      "volumeOfProduct": "产品体积",
      "productQuantity": "产品数量",
      "productRecipientId": "产品收件人 ID",
      "productRecipientName": "产品收件人姓名",
      "productRecipientType": "产品接收者类型",
      "singleProduct": "单品",
      "orderPlaced": "订单已下",
      "orderNotPlaced": "未下订单",
      "totalPrice": "总价",
      "currency": "货币",
      "selectCurrency": "选择货币",
      "address": "地址",
      "enterAddress": "输入地址",
      "attachments": "附件",
      "chooseFile": "选择文件",
      "nameOfTheFarm": "农场名称",
      "loremIpsumHasBeenTheIndustrySStandardDummyText": "自 1500 年代以来，Lorem Ipsum 一直是行业标准的虚拟文本，当时一位未知的打印机使用了",
      "billedTo": "付款人",
      "orderStatus": "订单状态",
      "selectStatus": "选择状态",
      "cadbury": "吉百利",
      "totalAmount": "总金额",
      "deliveryCharges": "送货费",
      "orderDetails": "订单详细信息",
      "deliveryOnTime": "准时交货",
      "productID": "产品编号",
      "productRegistration": "产品注册",
      "enterTheNameOfTheProduct": "输入产品名称",
      "nameOfTheProduct": "产品名称",
      "productAdded": "产品已添加",
      "productNotAdded": "产品未添加"
    },
    "drug": {
      "dRUGS": "药品",
      "registerAdrug": "注册药品",
      "sEARCH": "搜索",
      "genericName": "通用名",
      "manufacturer": "制造商",
      "distributor": "经销商",
      "registrationDate": "注册日期",
      "drugRegistration": "药品注册",
      "drugInformation": "药品信息",
      "packExpiration": "包有效期",
      "drugId": "药品编号",
      "drugName": "药品名称",
      "drugGenericname": "药品通用名",
      "drugManufacturer": "药品生产商",
      "distributorName": "经销商名称",
      "drugRegistrationdate": "药品注册日期",
      "nextDrug": "下一个药物",
      "editDrug": "编辑药物",
      "updateDrug": "更新药物",
      "deleteDrug": "删除药品",
      "noRecordfound": "没有找到记录",
      "addDrug": "添加药物",
      "statementDrug": "该药物已被删除。 ",
      "cANCEL": "取消",
      "cONFIRM": "确认",
      "sTATEMENT": "您确定要删除此记录吗？",
      "ok": " 好的",
      "information": "信息",
      "packOrder": "包装订单",
      "packPrescription": "包处方",
      "packReservation": "打包预订",
      "packLocation": "包装地点",
      "drugDozedam": "大坝一天用药剂量",
      "drugDozecalf": "犊牛一天用药剂量",
      "drugFormate": "药物形式",
      "drugDistributor": "药品经销商",
      "drugActiveingridents": "药物活性成分",
      "drugSubstitutionId": "药物替代品 ID",
      "packId": "包编号",
      "packBatchNumber": "包装批号",
      "drugIdStatement": "药品的批号。",
      "drugNameSatement": "销售药物的广告品牌名称。",
      "drugGenericnameStatement": "药物的化学成分，而不是销售药物的广告品牌名称。",
      "drugFormateSatement": "药品的批号。",
      "drugDozecalfSatement": "了解犊牛用药剂量的多少。",
      "drugDozedamStatement": "了解大坝用药剂量的多少。",
      "drugManufacturerStatement": "药品制造商的详细信息。",
      "drugDistributorStatement": "药品经销商的详细信息。",
      "drugRegistrationdateStatement": "特定国家的药品注册日期。",
      "drugActiveingridentsStatement": "活性成分列表。",
      "drugSubstitutionIdStatement": "在主要药物当前不可用的情况下，可能替代药物的 ID。",
      "packIdStatement": "包装的条形码或 RF ID。",
      "packBatchNumberStatement": "制造商分配给包装的批号。",
      "locationWarehouseID": "位置 仓库 ID",
      "locationWarehouseIDState": "存放包裹的仓库ID。",
      "locationRackID": "位置机架 ID",
      "locationRackIDStatement": "存储包的机架的 ID。",
      "locationTierID": "位置等级 ID",
      "locationTierIDStatement": "存储包的机架上层的 ID。",
      "locationPositionID": "位置 位置 ID",
      "locationPositionIDStatement": "包所在层的位置ID。",
      "storageTemperatureCondition": "储存温度条件",
      "storageTemperatureConditionStats": "包装储存条件。",
      "containerForm": "集装箱形式",
      "containerFormStatement": "包装药物的容器形式。",
      "consistQuantity": "组成 数量",
      "consistQuantityStatement": "包装中药丸、瓶子等的数量。",
      "releaseId": "版本号",
      "releaseIdStatement": "农民取包后分配的 ID。",
      "releaseDate": "发布日期",
      "releaseDateStatement": "农民从库存中取出包装的日期。",
      "packManufacturedDate": "包装制造日期",
      "packManufacturedDateStatement": "包装的制造日期。",
      "packImportedDate": "包装进口日期",
      "packImportedDateStatement": "导入包的日期。",
      "packExpirationDate": "包装有效期",
      "packExpirationDateStatement": "包装过期日期。",
      "expiredSoonFlag": "即将过期标志",
      "expiredSoonFlagState": "关于该包即将过期的警告。",
      "packTotalVolumeLeft": "剩余包装总体积",
      "packTotalVolumeLeftState": "库存中相同成分的包装总数。",
      "packOrderID": "包装订单 ID",
      "packOrderIDState": "从经销商处订购包装后分配的 ID。",
      "packQuantityOrdered": "订购包装数量",
      "packQuantityOrderedState": "从经销商处订购的包装数量。",
      "packPrice": "包装价格",
      "packPriceStatement": "包的价格。",
      "priceCurrency": "价格货币",
      "packPricecurrency": "套餐价格货币",
      "packPricecurrencyState": "指定价格的货币名称。",
      "packPaydate": "打包付款日期",
      "payDate": "发薪日期",
      "packPaydateState": "付款发放给经销商的日期。",
      "packShippingID": "包装运输 ID",
      "shippingID": "运输编号",
      "packShippingIdState": "包装从经销商到达时的运输 ID。",
      "packShippingDate": "包装发货日期",
      "shippingDate": "发货日期",
      "packShippingDateState": "包装到达库存的日期。",
      "packOrderStatus": "包装订单状态",
      "packOrderStatusState": "当前订单的状态。",
      "recepientKeeperId": "收件人管理员 ID",
      "recepientKeeperIdStatement": "收到包裹的个人/组织的姓名。",
      "recepientFarmId": "接收农场 ID",
      "recepientFarmIdStatement": "兽药收据所属养殖场ID。",
      "recepientAnimalId": "接收动物 ID",
      "recepientAnimalIdState": "为其开出药物（包）的动物的 ID。",
      "specialistComments": "专家点评",
      "specialistCommentsState": "专家/兽医对处方的评论。",
      "specialistName": "专家姓名",
      "specialistNameState": "开药的专家/兽医的姓名。",
      "specialistID": "专家 ID",
      "specialistIDState": "开药的专家/兽医的 ID。",
      "reservedByKeeperId": "由 Keeper ID 保留",
      "reservedByKeeperIdState": "预订包的保管人 ID。",
      "reservedByFarmId": "按农场 ID 保留",
      "reservedByFarmIdState": "为其保留包的农场 ID。",
      "reservationTimeoutDate": "预约超时日期",
      "reservationTimeoutDateState": "如果未购买套餐，预订将自动取消的日期。",
      "reservationTimeout": "预约超时",
      "reservationTimeoutState": "如果未购买或领取套餐，预订将在多少小时后自动取消",
      "reservationDate": "预订日期",
      "reservationDateState": "套餐的预订日期。",
      "reservationStatus": "预订状态",
      "reservationStatusState": "包预订的状态。",
      "loadingDrugsPleaseWait": "正在加载药物...请稍候",
      "quantityOrder": "数量 订单",
      "keeperID": "管理员 ID",
      "timeoutDate": "超时日期",
      "warehouseID": "仓库编号",
      "rackID": "机架编号",
      "tierID": "等级 ID",
      "positionID": "职位编号",
      "temperatureCondition": "温度条件",
      "manufactureDate": "生产日期",
      "importedDate": "进口日期",
      "totalVolumeLeft": "剩余总音量"
    },
    "reports": {
      "myReports": "我的报告",
      "satelliteReports": "卫星报告",
      "weatherReports": "天气预报",
      "pregnancyAnalytics": "妊娠分析",
      "semenEmbroyAnalytics": "精液/胚胎分析",
      "semenAnalytics": "精液分析",
      "embryoAnalytics": "胚胎分析",
      "calfAnalytics": "小牛分析",
      "milkProduction": "牛奶生产",
      "totalMilkType": "总牛奶类型",
      "totalAnimalAnalytics": "全面动物分析",
      "animalAnalytics": "动物分析",
      "analyticsAndReporting": "分析和报告",
      "filterByCountry": "按国家过滤",
      "filterByFarm": "按农场过滤",
      "filterByRegion": "按地区过滤",
      "filterByMonth": "按月份过滤",
      "filterByDate": "按日期过滤",
      "filterByRole": "按角色过滤",
      "filterByYear": "按年份过滤",
      "filterByTrait": "按特征过滤",
      "avgBreedingValue": "平均育种值",
      "avgEconomicIndex": "平均经济指数",
      "breederReport": "饲养员报告",
      "semenTransferDate": "精液移植日期",
      "semenEmbryoProductionReport": "精液/胚胎生产报告",
      "semenProducts": "精液产品",
      "meatProducts": "肉制品",
      "totalProducts": "产品总数",
      "semenEmbryoReport": "精液/胚胎报告",
      "numOfStraws": "吸管数量",
      "collectionDate": "采集日期",
      "productionReport": "生产报告",
      "receipientId": "收件人 ID",
      "embryoId": "胚胎识别",
      "semenStrawId": "精液管内径",
      "dataScientist": "数据科学家",
      "dataScientistReport": "数据科学家报告",
      "productReport": "产品报告",
      "dairyProducts": "乳制品"
    },
    "genoPerformance": {
      "performanceOfGenoType": "基因型的性能",
      "addAGenoType": "添加基因类型",
      "breedName": "品种名称",
      "chromosome": "染色体",
      "sequenceChange": "顺序改变",
      "inheritance": "遗产",
      "diseaseName": "疾病名称",
      "referenceSequence": "参考序列",
      "pubmedReference": "出版参考文献",
      "genoTypeRegistration": "基因型注册",
      "breed": "品种",
      "editAGenoType": "编辑基因类型",
      "editGenoType": "编辑基因类型",
      "loadingGene": "正在加载 Geno...请稍候",
      "geneTypeList": "基因型列表"
    },
    "reportings": {
      "conception": "构想（数据科学家）",
      "performanceOfGenoData": "基因型表现（数据科学家）",
      "totalInsemination": "全授精",
      "embryo": "胚胎",
      "animalVaccinationRecord": "动物疫苗接种记录",
      "dataNotAvailable": "该农场没有可用数据。",
      "pregnancyStatus": "怀孕状况",
      "healthReport": "健康报告",
      "heavyMilk": "浓牛奶",
      "standardMilk": "标准牛奶"
    },
    "sidebar": {
      "healthAnalytics": "健康分析",
      "productionAnalytics": "生产分析"
    },
    "epd": {
      "regNo": "动物注册号是使用标记方式赋予动物的唯一代码，确保完成识别和跟踪特定动物的过程",
      "internationalID": "动物的国际身份证",
      "location": "动物出生的国家/地区 ",
      "animalName": "动物的标准名称/命名法",
      "gender": "动物的性别（雄性/雌性）",
      "additionalIDMethod": "使用什么方法来识别动物（例如耳标、纹身）",
      "damID": "动物母亲的 ID 或登记号 - 动物的母本/生母的 ID 号",
      "sireId": "动物父本的 ID 或注册号，尤其是用于繁殖的公牛或用于人工授精的公牛精液。",
      "dateOfBirth": "动物的出生日期。",
      "breederHerdCode": "饲养者群体代码主要由饲养者协会给出",
      "seasonofBirth": "按月份记录动物的出生季节",
      "birthYear": "动物出生的年份",
      "birthManagementCode": "生育管理代码主要由用户/农民提供",
      "birthSex": "动物的性别（雄性/雌性）",
      "birthWeight": "犊牛出生体重 ",
      "primaryBreed": "动物的主要遗传贡献百分比 ",
      "secondaryBreed": "动物的次要遗传贡献百分比 ",
      "breedComposition": "品种组成百分比是指单个动物或一组动物的基因组成中不同品种的比例。",
      "conceptionMethod": "动物是如何受孕的（自然交配/授精/胚胎移植）。",
      "accuracyWeight": "准确度重量",
      "damAge": "大坝的年龄（以月/年为单位），例如",
      "weaningWeight": "断奶时动物的体重。",
      "weaningDate": "动物断奶的日期",
      "weaningSex": "断奶动物的性别。",
      "managementPastureCode": "用户/农民向管理/牧场提供的代码 ",
      "creep": "教槽饲喂是向哺乳期犊牛提供补充饲料（谷物或草料）的做法。",
      "weaningContemporaryGroupCode": "断奶体重规范当代组",
      "birthContemporaryCode": "出生当代代码",
      "yearlingDate": "动物一岁或二岁的日期",
      "managementFeedUnitCode": "用户向管理/饲料单位提供的代码",
      "yearlingSex": "一岁时动物的性别 ",
      "yearlingWeight": "一岁体重是断奶后直接生长的衡量标准，通常用于反映饲养场中上市后代的潜在表现，以犊牛磅为单位。",
      "yearlingHeight": "动物一岁时的身高 ",
      "yearlingWeightContemporaryGroupCode": "一岁体重代码当代组",
      "weaningYearlingWeightContemporaryGroupCode": "现代组断奶或一岁体重代码",
      "daysOnFeed": "使用特定饲料喂养的天数 例如：用高能量饲料喂养正在生长的年轻牛，以较低的增重成本生产出适销对路的牛肉。",
      "managementFeedUnitPenCode": "用户向管理/饲料单位/围栏提供的代码",
      "harvestDate": "屠宰（宰杀）肉食动物的日期",
      "gradingDate": "根据特定标准对屠体日期进行分级",
      "carcassSex": "尸体性别",
      "dateonFeed": "动物改用新饲料的日期 例如：正在生长的幼牛采用高能量饲料喂养，以较低的增益成本生产出适销对路的牛肉。",
      "KPH": "% KPH 是屠体体腔中（特别是肾脏、骨盆和心脏区域）中发现的总脂肪的百分比。",
      "carcassWeight": "胴体重量是收获并除去皮、头、胃肠道和内脏后的热重或未冷藏重量。",
      "fatThickness": "使用小尺子测量脂肪厚度，以英寸为单位。",
      "marbling": "大理石花纹是积累在肌肉内和肌纤维束之间的可见的不饱和（健康）肌内脂肪。",
      "ribeyeArea": "使用网格（例如 8、9 或 10 英寸）在第 12 和第 13 肋骨之间测量的肋眼（腰部或肋眼肌背最长肌）面积量，以平方英寸为单位。",
      "animalStatus": "农场动物的状况，例如：健康、患病等"
    },
    "manageAnimalGroupings": {
      "resetModeTooltip": "\n        复位模式 <br>\n            在此模式下 <br>\n            1) 为所有感兴趣的特征设置/定义所有当代群体 (CG) 特征。 <br>\n            2) 将所有动物分配到相应的CG。 <br>\n            3) 如果动物的分配不理想，则调整/更改CG，然后再次将动物分配到新的相应CG。 <br>\n            4) 如有必要，请重复上述步骤，直到您对 CG 和相应的动物分组/分配感到满意为止。<br>\n        ",
      "maintainanceModeHeadingTooltip": "一旦重置（模式）完成，您将进入维护模式，其中重置时计算的 EDP 对于每只动物将保持恒定，直到下一次重置（可能是 2-6 个月后）。",
      "maintainanceModeTooltip": "完成RESET MODE后，按RESET FINALIZED按钮使系统计算所有动物的EPD，终止RESET MODE，并启动MAINTENANCE MODE。",
      "resetToggleTooltip": "在 EPD 模型设置中启用重置切换，将动物分配给 CG。"
    },
    "geneticsAndBreeding": {
      "geneticsAndBreeding": "遗传学",
      "geneticSearchTool": "基因搜索工具",
      "dataSubmission": "数据提交/动物选择",
      "animalsWithExpectedProgenyDifferences": "预期后代差异 (EPD) 计算的动物选择",
      "searchByAnimalIdName": "按动物 ID、名称搜索",
      "rowsPerPage": "每页行数",
      "individualEntry": "个人参赛",
      "bulkEntry": "批量输入",
      "registerANewAnimalOrSelectAnExistingAnimal": "注册新动物或选择现有动物。",
      "registerNewAnimal": "注册新动物",
      "selectExistingAnimal": "选择现有动物",
      "animalID": "动物ID",
      "animalName": "动物名称",
      "tag": "标签",
      "dateOfBirth": "出生日期",
      "gender": "性别",
      "birthDate": "出生日期",
      "birthWeightLb": "出生体重（磅）",
      "birthWeightKg": "出生体重（公斤）",
      "weaningWeightLb": "断奶体重（磅）",
      "weaningWeightKg": "断奶体重(kg)",
      "yearlingWeightLb": "一岁体重（磅）",
      "yearlingWeightKg": "一岁体重(公斤)",
      "carcassWeightLb": "胴体重量（磅）",
      "carcassWeightKg": "胴体重量(kg)",
      "animalSelection": "动物选择",
      "animalSearchTool": "动物搜索工具",
      "back": "后退",
      "searchByEPDs": "按环保署搜寻",
      "searchByIds": "按 ID 搜索",
      "selectBreed": "选择品种",
      "selectGender": "选择性别",
      "selectRequiredBreedForCattle": "选择所需的牛品种",
      "resetFilter": "重置过滤器",
      "birthWeightHeader": "出生体重（体重）： ",
      "birthWeightDef": "比较小牛出生时体重的差异，以磅或公斤为单位进行测量。",
      "weaningWeightHeader": "断奶体重（WW）： ",
      "weaningWeightDef": "WW EPD 是断奶前生长的估计值，以磅或公斤为单位。",
      "yearlingWeightHeader": "一岁体重(YW): ",
      "yearlingWeightDef": "YW EPD 是对断奶后生长的估计值，以磅或公斤为单位。",
      "ribEyeAreaHeader": "肋眼区域（REA）： ",
      "ribEyeAreaDef": "REA 以平方英寸为单位测量构成肋眼的肌肉大小。REA EPD 反映了基于收获牛胴体测量值调整后的 365 天肋眼面积测量值的差异。",
      "marblingHeader": "大理石花纹（MARB）： ",
      "marblingDef": "MARB EPD 以肋眼内肌内脂肪百分比为单位。MARB EPD 反映了基于收获牛胴体测量值调整后的 365 天大理石花纹评分（肌内脂肪，[IMF]）的差异。",
      "fatThicknessHeader": "脂肪厚度(FAT): ",
      "fatThicknessDef": "背膘英寸（百分之一英寸）是 FT 的测量单位。",
      "carcassWeightHeader": "胴体重量（CW）： ",
      "carcassWeightDef": "考虑到磅数对最终产品价值的影响时，胴体重量是一个有益的特性。",
      "yieldGradeHeader": "产量等级(YG): ",
      "yieldGradeDef": "美国农业部产量等级评分系统是 YG EPD 的衡量单位。 ",
      "milkHeader": "牛奶(MK): ",
      "milkDef": "由于小牛母亲的挤奶能力，MK EPD 以小牛断奶体重的磅数来衡量。",
      "totalMaternalHeader": "母体总计 (TM)： ",
      "totalMaternalDef": "TM 衡量产奶量和奶牛生长遗传因素对犊牛断奶体重的影响。",
      "calvingEaseDirectHeader": "轻松产犊直接 (CED)： ",
      "calvingEaseDirectDef": "CED EPD 列为无协助产犊的百分比。",
      "calvingEaseMaternalHeader": "产妇产犊难易度 (CEM)： ",
      "calvingEaseMaternalDef": "衡量公牛的女儿在两岁时无需协助即可产犊的能力。",
      "stayabilityHeader": "住宿性（STAY）： ",
      "stayabilityDef": "ST EPD 预测公牛繁殖“留下来”的奶牛的能力。 ",
      "docilityHeader": "顺从（DOC）： ",
      "docilityDef": "DOC 测量牛的性情。",
      "max": "最大限度",
      "min": "最小",
      "accuracy": "准确性",
      "sortBy": "排序方式",
      "traits": "以灰色显示的特征正在开发中，将于 2023 年第二季度推出。",
      "searchResults": "搜索结果",
      "recordsFound": "找到记录",
      "compareSelected": "比较所选内容",
      "animalIdentification": "动物识别",
      "errorMessage": {
        "birthWeight": "出生体重最大值不能小于出生体重最小值",
        "weaningWeight": "断奶体重最大值不能小于断奶体重最小值",
        "yearlingWeight": "一岁体重最大值不能小于一岁体重最小值",
        "carcassWeight": "胴体重量最大值不能小于出生体重最小值",
        "fatThickness": "脂肪厚度最大值不能小于断奶体重最小值",
        "marbling": "大理石花纹最大值不能小于一岁体重最小值",
        "ribeyeArea": "肋眼面积最大值不能小于出生体重最小值",
        "yieldGrade": "产量等级最大值不能小于断奶体重最小值",
        "milk": "牛奶最大值不能小于断奶体重最小值"
      },
      "reg": "注册",
      "name": "姓名",
      "sex": "性别",
      "tattoo": "纹身",
      "dob": "出生日期",
      "EPD": "环保署",
      "rank": "秩",
      "searchValue": "搜索值",
      "typeHere": "在此输入",
      "searching": "正在寻找...",
      "fetchingResult": "正在获取结果...请稍候",
      "animalsMatchedYourCriteria": "动物符合您的标准",
      "manageAnimalsGrouping": "管理动物分组",
      "manageAnimalGroupings": "管理动物分组",
      "assignAnimalToContemporaryGroups": "将动物分配给当代组",
      "resetMode": "复位模式",
      "enterResetMode": "进入重置模式",
      "maintainanceMode": "维护方式",
      "assigningAnimals": "分配动物",
      "excludedAnimals": "排除动物",
      "ungroupedAnimals": "未分组的动物",
      "assignAnimalsToCGS": "将动物分配给 CGS",
      "reset": "重置",
      "excludeAnimals": "排除动物",
      "resetToMaintainanceMode": "重置完成 - 更改为维护模式",
      "contemporaryGroupsSettings": "当代群体（CG）设置",
      "selectTrait": "选择特质",
      "selectTraitDescription": "选择特质是指选择特定特质的过程",
      "traitsType": {
        "birthWeight": "出生体重",
        "weaningWeight": "断奶体重",
        "yearlingWeight": "一岁体重",
        "carcassWeight": "胴体重量"
      },
      "addNewGroup": "添加新组",
      "contemporaryGroup": "当代集团",
      "contemporaryGroups": "当代团体",
      "editGroup": "编辑组",
      "birthCGCode": "出生（CG）代码",
      "groupName": "团队名字",
      "birthSex": "出生性别",
      "conceptionMethod": "受孕方法",
      "weaningCGCode": "断奶(CG)代码",
      "yearlingCGCode": "一岁鸽(CG)代码",
      "dateWeight": "日期重量",
      "weaningyearlingCGcode": "断奶/一岁鸽(CG)代码",
      "carcassCGCode": "胴体(CG)代码",
      "breedOfDom": "母系品种",
      "addNewContemporaryGroup": "添加新的当代组",
      "createNewGroup": "创建新组",
      "selectFromDifferentTraits": "从不同的特征中选择",
      "contemporaryGroupName": "当代团体名称",
      "enterNameHere": "在此输入姓名",
      "groupNameIsRequired": "群组名称为必填项",
      "birthYearRange": "出生年份范围",
      "theYearAnimalWasBorn": "动物出生的年份",
      "birthYearIsRequired": "出生年份为必填项",
      "genderOfNewBornAnimal": "新生动物的性别",
      "selectSex": "选择性别",
      "theweightOfAnimalAtBirth": "动物出生时的体重",
      "maximumKg": "最大限度",
      "minimumKg": "最低限度",
      "aSeasonisAPeriodOfYear": "季节是一年中以特殊气候条件为特征的时期。",
      "seasonofBirthIsRequired": "出生季节为必填项",
      "majorGenericContributionOfAnimal": "动物的主要仿制药贡献百分比",
      "primaryBreedCompostionIsRequired": "需要主要品种成分",
      "secondaryBreedCompostionIsRequired": "需要二级品种成分",
      "howTheAnimalWasConceived": "动物是如何受孕的（自然交配/授精/胚胎移植）",
      "conceptionMethodIsRequired": "受孕方法为必填项",
      "epdModelSettings": "EPD 模型设置",
      "forResetMode": "对于重置模式",
      "progenyWeightingFactor": "后代权重因子",
      "weightGivenToTheProgenyFactor": "在重置模式下进行 EPD 计算时，赋予子代因子相对于 CG 因子的权重。",
      "enterNumber": "输入号码",
      "enterBreed": "输入品种",
      "valueShouldBeBetween0and1": "值应介于 0 和 1 之间",
      "resetDuration": "重置持续时间",
      "timeIntervalBetweenLastAndFirstResetMode": "最后一次复位模式与新复位模式之间的时间间隔，在该时间间隔结束时启用新复位模式并计算新的 CG 和 EPD。",
      "enterNumberOfDays": "输入天数",
      "valueCannotBeNegative": "值不能为负数！",
      "criticalProgenyPopulation": "关键后代群体",
      "minimumNumberOfProgenyRecords": "系统中实现后代准确度 (APD1) 高于 50%（对于谱系准确度）所需的个体动物后代记录的最小数量",
      "criticalAncestorPopulation": "临界祖先种群",
      "minimumNumberOfAncestorsRecords": "系统中实现祖先准确度 (APD4) 高于 50%（对于谱系准确度）所需的单个动物的最小祖先记录数量",
      "forBirthWeightCG": "出生体重 CG",
      "criticalPopulationInAnimalsContemporaryGroup": "动物当代群体中的关键种群",
      "minimumAverageNumberOfAnimalsPerBirthWeight": "达到平均 CG 准确度 (ACG3) 高于 50% 所需的每出生体重 CG 的最小平均动物数量",
      "criticalAveragePopulationPerContemporaryGroup": "每个当代群体的临界平均人口",
      "minimumNumberOfAnimalsInBirthWeight": "达到 CG 准确度 (ACG2) 50% 以上所需的动物出生体重 CG 中的最小动物数量",
      "forWeaningWeightCG": "断奶体重CG",
      "minimumAverageNumberOfAnimalsPerWeaningWeight": "达到平均 CG 准确度 (ACG3) 高于 50% 所需的每断奶体重 CG 的最低平均动物数量",
      "minimumNumberOfAnimalsInWeaningWeight": "达到 CG 准确度 (ACG2) 50% 以上所需的动物断奶体重 CG 中的最小动物数量",
      "forYearlingWeightCG": "一岁体重 CG",
      "minimumAverageNumberOfAnimalsPerYearling": "达到平均 CG 准确度 (ACG3) 高于 50% 所需的每只一岁鸽 CG 的最低平均动物数量",
      "minimumNumberOfAnimalsInYearlingWeight": "达到 CG 准确度 (ACG2) 50% 以上所需的动物一岁体重 CG 中的最小动物数量",
      "forCarcassCG": "尸体CG用",
      "minimumAverageNumberOfAnimalsPerCarcassWeight": "达到平均 CG 精度 (ACG3) 高于 50% 所需的每屠体重量 CG 的最小平均动物数量",
      "minimumNumberOFAnimalInCarcassWeight": "达到 CG 精度 (ACG2) 50% 以上所需的动物胴体重量 CG 中的最小动物数量",
      "epdRequiredFieldSettings": "EPD 必填字段设置",
      "pleaseSelectRequiredFieldsForCompleteEPD": "请选择完整 EPD 计算所需的字段",
      "byDefault": "默认情况下",
      "pleaseNoteThatUsersNotAbleToObtainFullEPD": "注意：请注意，如果用户不提供您标记为必填的数据字段，他们将无法获得完整的 EPD 计算。",
      "pleaseNoteThatRequiredFieldParametersCannotBeChanged": "注意：请注意，必需的字段参数无法更改，因为已经存在针对先前参数的当代组。",
      "noResultFound": "没有找到结果",
      "next": "下一个",
      "cancel": "取消",
      "selectAnimal": "选择动物",
      "searchBy": "搜索依据",
      "breed": "品种",
      "regDate": "注册。",
      "status": "地位",
      "animalDetails": "动物详情",
      "add": "添加",
      "update": "更新",
      "dataForEPDs": " 环保署数据",
      "basicInformation": "基本信息",
      "birthWeightInformation": "出生体重信息",
      "weaningWeightInformation": "断奶体重信息",
      "yearlingWeightInformation": "一岁体重信息",
      "carcassWeightInformation": "胴体重量信息",
      "delete": "删除",
      "deleteEpdData": "删除 EPD 数据",
      "areYouSureYouWantToDeleteEpdData": "您确定要删除 EPD 数据吗？",
      "internationalID": "国际身份证",
      "enterID": "输入身份证号",
      "animalRegistration": "动物登记",
      "location": "地点",
      "additionalIDMethod": "附加ID方法",
      "damID": "大坝编号",
      "sireID": "父系 ID",
      "breederHerdCode": "种猪群代码",
      "birthYear": "出生年",
      "primaryBreed": "主要品种",
      "breedComposition": "品种组成",
      "secondaryBreed": "次要品种",
      "seasonofBirth": "出生季节",
      "birthManagementCode": "生育管理法规",
      "damAge": "损害",
      "years": "年",
      "birthContemporaryCode": "出生当代代码",
      "accuracyWeight": "准确度重量",
      "note": "笔记",
      "minimumRequiredFieldForBirthWeight": "出生体重 EPD 的最低必填字段",
      "birthYearGenderConceptionMethodBirthWeight": "出生年份 , 性别 , 受孕方式 , 出生体重",
      "weaningWeight": "断奶体重",
      "weaningDate": "断奶日期",
      "weaningContemporaryGroupCode": "断奶当代集团代码",
      "creep": "蠕变",
      "managementPastureCode": "管理/牧区法规",
      "weaningSex": "断奶性行为",
      "minimumRequiredFieldForWeaningWeight": "断奶体重 EPD 的最低要求字段",
      "weaningWeightManagementPastureCodeWeaningSexDateWeighed": "断奶体重、管理/牧场法规、断奶性别、称重日期",
      "yearlingWeight": "一岁体重",
      "yearlingHeight": "一岁身高",
      "yearlingDate": "一岁日期",
      "yearlingContemporaryGroupCode": "一岁当代集团代码",
      "managementFeedingCode": "管理/饲养守则",
      "yearlingSex": "一岁性别",
      "youWillNeedToFillOutFor": "您需要填写所有字段才能检索 EPD 数据",
      "pleaseSelectHavestDateFirstToEnterInfo": "请先选择“收获日期”以输入有关肋眼面积、脂肪厚度和大理石花纹的信息",
      "harvestDate": "收获日期",
      "dateOnFeed": "喂食日期",
      "daysOnFeed": "喂养天数",
      "gradingDate": "评分日期",
      "carcassSex": "尸体性别",
      "carcassWeight": "胴体重量",
      "carcassContemporary": "当代屠体",
      "damBreed": "大坝品种",
      "ribEyeArea": "肋眼区",
      "ribEyeAreaContemporary": "肋眼区 现代风格",
      "fatThickness": "脂肪厚度",
      "fatThicknessContemporary": "脂肪厚度当代",
      "marbling": "大理石花纹",
      "marblingContemporary": "当代大理石花纹",
      "yieldGradeContemporary": "产量等级当代",
      "animalsNotListedInContemporaryGroupsMsg": "由于信息缺失，动物尚未被添加到任何当代群体中。",
      "listOfUngroupedAnimals": "未分组的动物列表",
      "submittingData": "提交数据",
      "resendToUser": "重新发送给用户",
      "submittingAnimalsInGroupMsg": "将您的动物分组。",
      "pressingResetBtnMsg": "按下“重置”按钮将启动将动物重新分配到其当代组的过程。",
      "doYouWantToProceed": "您想继续吗？",
      "systemMaintainanceModeMsg": "按下“更改为维护模式”按钮将启动一个过程，您的系统将进入“维护模式”，其中重置时计算的 EDP 将针对每只动物保持恒定，直到下一次重置（可能是 1-6 个月）",
      "errorFetchingContemporaryGrpMsg": "获取当代组数据时出错",
      "deleteSuccess": "删除成功",
      "deleteSuccessMsg": "当代群组删除成功。",
      "deleteFailed": "删除失败",
      "deleteFailedMsg": "删除当代组数据时出错",
      "deleteContemporaryGrpMsg": "您确定要删除这个当代群组吗？",
      "addBirthWeightData": "添加出生体重数据",
      "addWeaningWeightData": "添加断奶体重数据",
      "birthWeightContemporaryGroupCode": "出生体重当代组代码",
      "dateWeighted": "日期加权",
      "addYearlingWeightData": "添加一岁体重数据",
      "addCarcassWeightData": "添加胴体重量数据",
      "weaningOrYearlingContemporaryGroupCode": "断奶或一岁体重当代组代码",
      "deleteContemporaryGroupMsg": "您确定要删除当代组吗？",
      "updateSuccessMsg": "当代组更新成功。",
      "errorMsg": "出了些问题。",
      "fetchErrorMsg": "获取所选特征的必填字段时出错。",
      "forMaintainanceMode": "对于维护模式",
      "ancestorsWeightFactor": "祖先权重系数",
      "weightGivenToTheAncestorFactor": "在维护模式下，为 EPD 计算赋予祖先因子相对于 CG 因子的权重。",
      "addEPDModelSettingsData": "添加 EPD 模型设置数据",
      "minimumNumberOfAnimalsInContemporaryGroups": "当代群体中动物的最低数量",
      "enterNumberOfAnimals": "输入动物数量",
      "areYouSureYouWantToChangeEPDCalculation": "您确定要更改所需的 EPD 计算字段吗？",
      "weightOfAnimalAtBirth": "动物出生时的体重",
      "seasonIsAPeriodOfYear": "季节是一年中以特殊气候条件为特征的时期。",
      "codeOfBirthWeightContemporaryGroup": "出生体重代码当代组",
      "weaningWeightOfCalf": "犊牛断奶体重",
      "dateAnimalWasWeaned": "动物断奶的日期",
      "genderOfWeaningAnimal": "断奶动物的性别",
      "yearlingWeightOfCalf": "犊牛一岁体重",
      "dateAnimalWasWeighted": "动物称重的日期",
      "yearledAnimalSex": "一岁动物的性别",
      "dateOfAnimalKilledForMeat": "为肉而宰杀动物的日期",
      "addSuccessMsg": "当代组添加成功",
      "traitH": "EPD 计算的特征。",
      "searchByValue": "输入注册号/纹身/姓名/标签"
    }
  }